
import clienteAxios from "../config/axios";

export const getAllTareasXprocedimiento = async () => {
    return clienteAxios.get('/tareasXprocedimiento');
};
export const addTareasXprocedimiento = async (tareasXprocedimiento) => {
    return await clienteAxios.post('/tareasXprocedimiento',{tareasXprocedimiento});
}
export const updateTareasXprocedimiento = async (tareasXprocedimiento) => {
    return await clienteAxios.put(`/tareasXprocedimiento/${tareasXprocedimiento.id}`,{tareasXprocedimiento});
}
export const deleteTareasXprocedimiento = async () => {

}